
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Footer CTA */}
      <section className="py-20 bg-[#99CCCD]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 font-heading">
            Start Your Child's Journey Today
          </h2>
          <Button
            onClick={() => navigate("/signup")}
            variant="secondary"
            className="text-lg px-8 py-6 bg-[#03396C] text-white hover:bg-[#022a52]"
          >
            Get Started Now
          </Button>
        </div>
      </section>

      {/* Footer Links */}
      <footer className="py-8 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 text-sm md:text-base md:space-x-8">
            <div className="flex space-x-4 md:space-x-8">
              <Link 
                to="/privacy" 
                className="text-[#1A1F2C] font-semibold hover:text-[#005b96] transition-colors whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/legal-information" 
                className="text-[#1A1F2C] font-semibold hover:text-[#005b96] transition-colors whitespace-nowrap"
              >
                Legal Information
              </Link>
            </div>
            <Link 
              to="/terms" 
              className="text-[#1A1F2C] font-semibold hover:text-[#005b96] transition-colors whitespace-nowrap"
            >
              Terms & Acknowledgments
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
};
